import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDataWithParams } from 'src/consumer/services/profileService'
import {
  getDataMapFromCommonResponse,
  getParamsFromURI,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { updateApiGettingCalledStatusForPastReports } from 'src/reducers/emr/emrReducer'

const inFlightPastReportsRequests = new Map()

const getPastReportsRequestKey = ({
  patientId,
  referenceBookedEventId,
  patientHistoryGetApiSignature,
}) => `${patientHistoryGetApiSignature || '/api/secure/patient/reports/list'}|${patientId || ''}|${referenceBookedEventId || ''}`

export const getPastPatientReports = createAsyncThunk(
  'emr/getPastPatientReports',
  async (
    {
      patientId,
      referenceBookedEventId,
      patientHistoryGetApiSignature = '/api/secure/patient/reports/list',
    },
    { rejectWithValue, getState, dispatch },
  ) => {
    const requestKey = getPastReportsRequestKey({
      patientId,
      referenceBookedEventId,
      patientHistoryGetApiSignature,
    })
    const { emrStore } = getState()
    const currentPastReportsData = emrStore?.pastReports?.data
    const currentPatientId = currentPastReportsData?.patientId
    const currentReferenceBookedEventId = currentPastReportsData?.referenceBookedEventId
    const currentApiSignature = currentPastReportsData?.patientHistoryGetApiSignature

    if (
      !!currentPastReportsData &&
      currentPatientId === patientId &&
      currentReferenceBookedEventId === referenceBookedEventId &&
      currentApiSignature === patientHistoryGetApiSignature
    ) {
      return {
        ...currentPastReportsData,
        patientId,
        referenceBookedEventId,
        patientHistoryGetApiSignature,
      }
    }

    let uri = patientHistoryGetApiSignature
    let params = {
      patientId,
      referenceBookedEventId,
    }

    if (uri.includes('?')) {
      const paramsFromURI = getParamsFromURI(uri)
      if (paramsFromURI) {
        params = { ...params, ...paramsFromURI }
      }
      uri = uri.split('?')[0]
    }

    if (inFlightPastReportsRequests.has(requestKey)) {
    } else {
      dispatch(updateApiGettingCalledStatusForPastReports(true))
      const requestPromise = getDataWithParams(uri, params).finally(() => {
        inFlightPastReportsRequests.delete(requestKey)
      })
      inFlightPastReportsRequests.set(requestKey, requestPromise)
    }

    const resp = await inFlightPastReportsRequests.get(requestKey)

    if (resp?.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const respData = getDataMapFromCommonResponse(resp)
        dispatch(updateApiGettingCalledStatusForPastReports(false))
        return { ...respData, patientId, referenceBookedEventId, patientHistoryGetApiSignature }
      } else {
        dispatch(updateApiGettingCalledStatusForPastReports(false))
        return rejectWithValue(resp?.data?.message)
      }
    } else {
      dispatch(updateApiGettingCalledStatusForPastReports(false))
      return rejectWithValue(resp?.message || 'Failed to fetch past patient reports')
    }
  },
)
